import {
	SET_DASHBOARD_DATA
} from '../actions/types'; 

const initialState = {
	data : [],
	fields : [],
	columns:[],
	currentPage:1,
	totalPages:1,
	totalResult:1,
	startCount:1,
	endCount:1,
	sortBy:'',
	modelList:null,
	modelData:{},
	lastEditedOn:null
};

export default function dashboardReducer(state=initialState, action) {
    switch(action.type) {
        case SET_DASHBOARD_DATA:
            return {
				resultFound:action.payload.data && action.payload.data.length?true:false,
				data : action.payload.data,
				fields : action.payload.fields,
				dateFields: action.payload.dateFields || [],
				enumFields: action.payload.enumFields || [],
				enumFieldValues: action.payload.enumFieldValues || {}, 
				columns: action.payload.columns,
				currentPage:action.payload.currentPage,
				totalPages:action.payload.totalPages,
				totalResult:action.payload.totalResult,
				startCount:action.payload.startCount,
				endCount:action.payload.endCount.fields,
				sortBy:action.payload.sortBy || '',
				desc:action.payload.desc || false,
				modelList:action.payload.modelList,
				modelData:action.payload.modelData || {},
				modelName:action.payload.modelName,
				lastEditedOn:null
			}
		case 'SET_LAST_EDITED_ON':
			return {
				...state,
				lastEditedOn : action.payload.lastEditedOn
			}
		case "TOGGLE_DASHBOARD_COLUMN":
		let columns = state.columns;
		const key = action.payload;
		const index = columns.indexOf(key);
		if( index > -1){
			columns.splice(index,1)
		}
		else{
			columns.push(key);
		}
		
			return {
				...state,
				columns:[...columns]
			};
    };
    return state;
}